module.exports = __webpack_public_path__ + "img/motto.61913330.png";